// extracted by mini-css-extract-plugin
module.exports = {"otp_container":"OtpInput_otp_container__ivKC7","code":"OtpInput_code__3MXuQ"};